<div class="contentMain">
  <!-- breadcrumb -->
  <div class="row">
      <div class="col-md-6">
          <h4>Dashboard</h4>
      </div>
      <div class="col-md-6 ">
          <ol class="breadcrum d-flex justify-content-end">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
              <li class="breadcrumb-item active" aria-current="page">Index</li>
          </ol>
      </div>
  </div>
  <!--/ breadcrumb-->
  <!-- main body -->
  <main>
      <img src="./assets/images/dbimg.png" alt="" class="img-fluid w-100 ">
  </main>
  <!-- main body -->
</div>